import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { routes } from 'app/routes';
import Cookies from 'universal-cookie';
import AppLogout from '../appLogout';

const ProtectedRoutes = ({ nicRoutes, tosRoutes }) => {

  const cookies = new Cookies();
  const location = useLocation();

  const isTOSPath = location.pathname.startsWith('/tos');
  const tosCookie = cookies.get('nic-tos');
  const nicCookie = cookies.get('nic-portal');

  if (isTOSPath && tosCookie) {
    return <AppLogout cookie={tosCookie}>{tosRoutes}</AppLogout>;
  }

  if (nicCookie) {
    return <AppLogout cookie={nicCookie}>{nicRoutes}</AppLogout>;
  }

  return <Navigate to={routes.LOGIN} />;
};

export default ProtectedRoutes;
